import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "./actionCreators";
import { BugModalInvoker, ErrorEntity } from "./types";

export type State = {
  isOpen: boolean;
  message: string;
  errorStack: ErrorEntity[];
  lastInvocation: {
    invoker: BugModalInvoker | null;
    time: string;
    error?: ErrorEntity;
  };
  isSubmitting: boolean;
};

const initialState: State = {
  isOpen: false,
  message: ``,
  errorStack: [],
  lastInvocation: {
    invoker: null,
    time: "",
  },
  isSubmitting: false,
};

const bugReportReducer = reducer(
  initialState,

  on(AC.closeBugReportModal, (state) => {
    state.isOpen = false;
    state.message = "";
  }),
  on(AC.pushErrorToStack, (state, action) => {
    const { error } = action.payload;
    state.errorStack.push(error);
  }),
  on(AC.removeErrorFromStack, (state, action) => {
    const { index } = action.payload;
    const errors = state.errorStack;
    state.errorStack = errors.filter((_, i) => i !== index);
  }),
  on(AC.changeMessage, (state, action) => {
    const { message } = action.payload;
    state.message = message;
  }),
  on(AC.invokeBugReportModal, (state, action) => {
    const { error, invoker, time } = action.payload;

    state.lastInvocation = { error, invoker, time };
    state.isOpen = true;
  }),
  on(AC.submitBugRequest, (state, action) => {
    state.isSubmitting = true;
  }),
  on(AC.submitBugSuccess, (state, action) => {
    state.isSubmitting = false;
    state.message = "";
    const timeOfSubmittedErr = state.lastInvocation.error?.timeOfError;
    const indexOfSubmittedBug = state.errorStack.findIndex(
      (err) => err.timeOfError === timeOfSubmittedErr
    );

    if (indexOfSubmittedBug !== -1) {
      state.errorStack[indexOfSubmittedBug].bugReported = true;
    }
  }),
  on(AC.submitBugError, (state, action) => {
    state.isSubmitting = false;
  })
);

export default bugReportReducer;
export type BugReportSlice = State;
